import View from './view';
import {Props} from './model';

import {useAppDispatch} from '../../../../../redux';
import {useCallback, useEffect, useState} from 'react';
import {removeNotification} from '../../../../../redux/actions/snackbar';
import {useIsMounted} from '../../../../hooks/useIsMounted';
export const Notification = (props: Props) => {
  const dispatch = useAppDispatch();
  const {notification} = props;
  const [hideAnimationStart, setAnimationHide] = useState(false);
  const isMounted = useIsMounted();

  const onPressClose = useCallback(() => {
    setAnimationHide(true);
  }, [notification]);

  useEffect(() => {
    if (notification.duration === 0) {
      return;
    }

    setTimeout(() => {
      if (isMounted.current) {
        onPressClose();
      }
    }, notification.duration);
  }, []);

  return View({
    ...props,
    onPressClose,
    hideAnimationStart,
    onHideAnimationEnd: () => {
      dispatch(removeNotification(notification.id));
    },
  });
};
